import React from 'react';
import { FaTruck, FaFileInvoice, FaWhatsapp, FaChartBar, FaMoneyBillWave, FaCloud, FaUniversity } from 'react-icons/fa';
import './TallyFieldPage.css';

const ConnectedServices = () => {
  const sections = [
    {
      title: "e-Way Bill Generation",
      content: "Bid goodbye to manual work. TallyPrime directly integrates with the e-way portal as a recognized GSP to generate bills seamlessly without intervention.",
      icon: <FaTruck />,
    },
    {
      title: "e-Invoice Generation",
      content: "Direct integration with the IRP makes generating and printing e-invoices simple. Automatically authenticate data and print IRN & QR codes instantly.",
      icon: <FaFileInvoice />,
    },
    {
      title: "WhatsApp Integration",
      content: "Share invoices, orders, and reports directly from TallyPrime. Send bulk reminders and ledger reports in PDF, JPEG, or Excel formats instantly.",
      icon: <FaWhatsapp />,
    },
    {
      title: "Multi-Device Reports",
      content: "Access critical business reports like Profit & Loss and Balance Sheets from any device via a web browser, ensuring secure access on the go.",
      icon: <FaChartBar />,
    },
    {
      title: "Digital Payment Requests",
      content: "Integrate with RazorPay and PayU to share payment links. Add QR codes to invoices for faster collections and automated reconciliation.",
      icon: <FaMoneyBillWave />,
    },
    {
      title: "Secure Remote Access",
      content: "Access your business data anywhere, anytime. TallyPrime’s built-in security ensures your information remains protected while you're mobile.",
      icon: <FaCloud />,
    },
    {
      title: "Advanced e-Banking",
      content: "A seamless e-banking module for fund transfers and electronic cheques. Export transactions and upload them to portals for instant settlements.",
      icon: <FaUniversity />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Connected Services</h1>
          <p>Extend the power of TallyPrime with seamless cloud integrations and digital communication tools.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConnectedServices;
